import React, { Component } from 'react'
import UserTable from './components/UserTable'
import { Query } from 'react-apollo'
import styled from 'react-emotion'
import { color, spacer, Row, Container, Form, Input } from 'stylist'
import USERS_QUERY from './users.query'
import PageLoader from 'components/PageLoader'
import Debounce from 'components/Debounce'

const ContentRow = styled(Row)`
  background: ${color('offWhite')};
  padding-top: ${spacer(4)};
  min-height: 100vh;
`

class RouteAdminUsers extends Component {
  state = { search: '' }

  render() {
    const { search } = this.state
    return (
      <ContentRow>
        <Container>
          <Form.Group>
            <label>Search by Name or Email</label>
            <Debounce>
              {debounce => (
                <Input
                  onChange={e => {
                    e.persist()
                    debounce(() => this.setState({ search: e.target.value }))
                  }}
                  type="text"
                />
              )}
            </Debounce>
          </Form.Group>
          <Query query={USERS_QUERY} variables={{ search, limit: 1000 }}>
            {({ loading, data }) =>
              loading ? (
                <PageLoader />
              ) : (
                <UserTable users={data.users.edges.map(edge => edge.node)} />
              )
            }
          </Query>
        </Container>
      </ContentRow>
    )
  }
}

export default RouteAdminUsers



// WEBPACK FOOTER //
// ./src/routes/admin/users.js